import apiClient from "./axiosInstance";
/* ----------------  endpoints ---------------- */
// user auth
export const logIn = (payload) => apiClient.create("auth/api/login/", payload);
export const userRegistration = (payload) => apiClient.create("user-register/", payload);
export const logout = () => apiClient.create("auth/api/logout/")
export const userReFeralVerify = (payload) => apiClient.create("verify-referral-code/", payload);
export const forgotPassword = (payload) => apiClient.create("auth/api/send-otp/", payload);
export const changePassword = (payload) => apiClient.create("auth/api/change-password/", payload);
export const verifyOtp = (payload) => apiClient.create("auth/api/verify-otp/", payload);
export const resetPassword = (payload) => apiClient.create("auth/api/forgot-password-reset/", payload);
export const registerFcmToken = (payload) => apiClient.create("auth/api/fcm/register/", payload);
export const getProfile = () => apiClient.get("employees/api/profile/personal-info/");
export const UpdateProfile = (payload) => apiClient.update("employees/api/profile/personal-info/", payload, {
  headers: { "Content-Type": "multipart/form-data", },
});

// Attandance
export const getAttendance = (params) =>
  apiClient.get("attendance/api/employee/Attendance-Logs/", params ? { params } : undefined);
export const getAttendanceAPi = (url) => apiClient.get(url);
export const getAttendanceCards = (body) => apiClient.get("attendance/api/employee/dashboard-cards/", body ? { params: body } : undefined);
export const postCheckIn = () => apiClient.create("attendance/api/employee/check-in/");
export const postCheckOut = () => apiClient.create("attendance/api/employee/check-out/");
export const postBreakIn = () => apiClient.create("attendance/api/employee/break-start/");
export const postBreakOut = () => apiClient.create("attendance/api/employee/break-end/");

// Leave Apis
export const getLeaveDetails = (url) => apiClient.get(("attendance/api/employee/leave-options/"), url);
export const postApplyLeave = (payload) => apiClient.create("attendance/api/employee/leaves/apply/", payload);
export const postCancelLeave = (payload ,id ) => apiClient.create(`attendance/api/leaves/${id}/cancel/`, payload);
export const postCancelLeaveRequest = (payload ,id ) => apiClient.create(`attendance/api/leaves/${id}/request-cancellation/`, payload);
export const getLeaveBalances = () => apiClient.get("attendance/api/employee/upcoming-holidays/");
export const getUpcomingLeaves = (params) =>
  apiClient.get("attendance/api/upcoming-leaves/", params ? { params } : undefined);

// Help Desk
export const getListOfTickets = (query = "") =>
  apiClient.get(`support/api/tickets/${query}`);
export const getListOfTicketsApi = (url) => apiClient.get(url);
export const getCategoriesList = () => apiClient.get("support/api/categories/");
export const getTicketsView = (id) => apiClient.get(`support/api/tickets/${id}/`);
export const PostCommentAdd = (payload, id) => apiClient.create(`support/api/tickets/${id}/comments/`, payload);
export const PostUpload = (formData) => apiClient.create("support/api/tickets/attachments/", formData, {
  headers: { "Content-Type": "multipart/form-data", },
});
export const postRaiseTicket = (formdata) => apiClient.create("support/api/tickets/", formdata, {
  headers: { "Content-Type": "multipart/form-data", },
});
export const getHelpDeskTicketDetails = (ticketID) => apiClient.get(`support/api/tickets/${ticketID}/`);
export const DeleteCommentAdd = () => apiClient.delete("helpdesk/api/employee/tickets/");

// Notifications (backend)
export const getNotifications = (params) => apiClient.get("support/api/notifications/", params ? { params } : undefined);
export const markNotificationRead = (id) => apiClient.create(`support/api/notifications/${id}/read/`);

// Earnings & payslips
export const getEarnings = (query = "") =>
  apiClient.get(`payroll/api/employee/earnings/${query}`);
export const downloadPayslip = (id) =>
  apiClient.get(`payroll/api/employee/payslip/${id}/`, {
    responseType: "blob",
  });

//familly details
export const getFamilyDetails = () => apiClient.get("employees/api/profile/family-details/");
export const patchFamilyDetails = (payload) => apiClient.update("employees/api/profile/family-details/", payload);

/*  Profile Services */
export const getPersonalInfo = () => apiClient.get('employees/api/profile/personal-info/');
export const updatePersonalInfo = (data) => apiClient.update('employees/api/profile/personal-info/', data);
export const getPreviousEmployment = () => apiClient.get('/employees/api/profile/previous-employment/');
export const updatePreviousEmployment = (data) => apiClient.update('/employees/api/profile/previous-employment/', data);
export const getAccountStationary = () => apiClient.get('/employees/api/profile/accounts-statutory/');
export const updateAccountStationary = (data) => apiClient.update('/employees/api/profile/accounts-statutory/', data);
export const getNominationDetails = () => apiClient.get('/employees/api/profile/nomination-details/');
export const updateNominationDetails = (data) => apiClient.update('/employees/api/profile/nomination-details/', data);
export const getFamilyMembersList = () => apiClient.get('/employees/api/profile/family-details/');
export const getDocuments = () => apiClient.get('employees/api/profile/documents/');
export const getDocumentsTypes = () => apiClient.get('employees/api/profile/document-types/');
export const uploadDocument = (formData) => apiClient.update('employees/api/profile/documents/', formData, {
  headers: { 'Content-Type': 'multipart/form-data' }
});
export const deleteDocument = (id) => apiClient.delete(`employees/documents/${id}/`);
export const downloadDocument = (id) =>
  apiClient.get(`employees/documents/download/${id}/`, {
    responseType: "blob",
  });

// Approvals
export const getAllLeaveApprovals = (query = "") =>
  apiClient.get(`hr_operations/api/all/${query}`);
export const getAllLeaveApprovalsApi = (url) => apiClient.get(url);
export const getCorrectionApprovals = (query = "") =>
  apiClient.get(`hr_operations/api/corrections/${query}`);
export const getCorrectionApprovalsAPi = (url) => apiClient.get(url);
export const getLeaveApprovals = (query = "") =>
  apiClient.get(`hr_operations/api/leaves/${query}`);
export const getLeaveApprovalsApi = (url) => apiClient.get(url);
export const postRaiseRequest = (payload) => apiClient.create("hr_operations/api/raise-request/", payload ,{
  headers: { 'Content-Type': 'multipart/form-data' }
});
export const postRaiseRequestApi = (payload) => apiClient.create("hr_operations/api/raise-request/", payload );
export const postAttendanceCorrection = (payload) =>
  apiClient.create("hr_operations/api/corrections/", payload);
export const getResignation = (payload) => apiClient.get("hr_operations/api/resignations/", payload);
export const getReimbursement = (payload) => apiClient.get("approvals/api/claims/", payload);
export const getReimbursementTypes = (payload) => apiClient.get("hr_operations/api/claims/", payload);
export const getSalaryHike = (payload) => apiClient.get("hr_operations/api/salary-hikes/", payload);
export const getExpenses = (payload) => apiClient.get("hr_operations/api/expenses/", payload);
export const getExpensiveTypes = (payload) => apiClient.get("hr_operations/api/expenses/categories/", payload);
export const getSalaryAdvance = (payload) => apiClient.get("hr_operations/api/salary-advances/", payload);
export const getClaims = (payload) => apiClient.get("hr_operations/api/claims/", payload);
export const getClaimsTypes = (payload) => apiClient.get("hr_operations/api/claim-types/", payload);
export const getAllServices = () => apiClient.get("hr_operations/api/service-types/");

// Dashboard
export const getDashboardData = () => apiClient.get("employees/api/dashboard/");
export const getPolicyCategories = () => apiClient.get("policies/api/categories/");
export const getPoliciesList = (categoryID) => apiClient.get(`policies/api/list/?category=${categoryID}`);

//engage
export const getAllPosts = (params) => apiClient.get("/engage/api/posts/", { params });
export const getAllPolls = (params) => apiClient.get("/engage/api/my-polls/", { params });
export const addVote = (pollId, payload) => apiClient.create(`/engage/api/polls/${pollId}/vote/`, payload);
export const addRection = (postId, payload) => apiClient.create(`/engage/api/posts/${postId}/react/`, payload);
export const getAll = (params) => apiClient.get("/engage/api/my-activity/", { params });
export const getAllGroups = () => apiClient.get("/engage/api/my-accessible-groups/");
export const getAllGroupsList = (url) => apiClient.get(url);
export const getAllGroupsBySOrt = (query) => apiClient.get(`engage/api/my-accessible-groups/?${query}`);

// Assets
export const getAsset = (params) => apiClient.get("hr_operations/api/assets/", { params });
export const getAssetDetails = (id) => apiClient.get(`hr_operations/api/assets/assignments/${id}/`);
export const getMyAssets = (params) => apiClient.get("hr_operations/api/assets/requests/mine/", { params });
export const getIncomingAssets = (params) => apiClient.get("hr_operations/api/assets/requests/incoming/", { params });
export const getAssetDropdownList = () => apiClient.get("hr_operations/api/assets/dropdowns/");
export const getEmployeeList = () => apiClient.get("hr_operations/api/assets/transfer/employees/");
export const postAssetTransferRequest = (body) => apiClient.create("hr_operations/api/assets/transfer/request/", body);
export const postAssetReturnRequest = (body) => apiClient.create("hr_operations/api/assets/return/",body);
export const postAssetaccept= (id) => apiClient.create(`hr_operations/api/assets/transfer/requests/${id}/accept/`);
export const postAssetReject = (id) => apiClient.create(`hr_operations/api/assets/transfer/requests/${id}/reject/`);

// TDS
export const getHRAs = (params) => apiClient.get("payroll/api/tds/hra/", { params });
export const postAddHRA = (payload) => apiClient.create("payroll/api/tds/hra/", payload);
export const getProofs = (params) => apiClient.get("payroll/api/tds/proofs/", { params });
export const postUploadProof = (formData) => apiClient.create("payroll/api/tds/proofs/upload/", formData, {
  headers: { "Content-Type": "multipart/form-data", },
});
export const getTaxRegime = () => apiClient.get("payroll/api/tds/regime/");
export const postUpdateTaxRegime = (payload) => apiClient.create("payroll/api/tds/regime/", payload);

